import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Text } from '@uhg-abyss/web/ui/Text';
import { isEmpty, isUndefined } from 'lodash';
import React from 'react';

/**
 * RiskScore
 *
 * Displays a letter representing the risk score with a color that corresponds to the risk code.
 *
 * @param ireRiskRecord
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function RiskScore({ ireRiskRecord = {}, riskRecord = {} }) {
  let riskCode = '';

  if (!isUndefined(riskRecord?.ireRiskRecord?.riskScore)) {
    riskCode = riskRecord?.ireRiskRecord?.riskScore;
  }

  if (!isUndefined(ireRiskRecord?.riskReports?.[0]?.publishedRisk)) {
    riskCode = ireRiskRecord?.riskReports?.[0]?.publishedRisk;
  }

  const codes = riskCode?.split('-');
  const letter = codes.shift().toUpperCase();

  return (
    <ErrorHandler location="src/pages/private/Analysis/EidSearch/components/Details/components/RiskScore/RiskScore.jsx">
      <React.Fragment>
        {isEmpty(riskCode) ? (
          <Text color="$gray5">&mdash;</Text>
        ) : (
          <React.Fragment>
            {letter === 'R' && (
              <Text color={themeConfiguration?.theme?.colors?.error1} fontWeight="bold">
                <div>{letter} (Red)</div>
              </Text>
            )}

            {letter === 'Y' && (
              <Text color={themeConfiguration?.theme?.colors?.warning1} fontWeight="bold">
                <div>{letter} (Yellow)</div>
              </Text>
            )}

            {letter === 'G' && (
              <Text color={themeConfiguration?.theme?.colors?.success1} fontWeight="bold">
                {letter} (Green)
              </Text>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    </ErrorHandler>
  );
}
